if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          if (window.FoxTheme && window.FoxTheme.Motion && window.FoxTheme.Motion.inView) {
            FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
          } else {
            this.init();
          }
        }
      }

      init() {
        if (!this.dataset.url) return;

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            const hasProducts = this.querySelector('.card-product, .product-card, .f-column');

            if (hasProducts) {
              this.dispatchEvent(new CustomEvent('recommendations:loaded', { bubbles: true }));
            } else {
              const sectionWrapper = this.closest('.shopify-section');
              if (this.classList.contains('complementary-products')) {
                const block = this.closest('.product__block');
                if (block) block.remove();
              } else if (sectionWrapper) {
                sectionWrapper.remove();
              }
              this.dispatchEvent(new CustomEvent('recommendations:empty', { bubbles: true }));
            }
          })
          .catch((e) => {
            console.error('Error fetching recommendations:', e);
          });
      }
    }
  );
}